export const E8S_PER_TOKEN = BigInt(100000000);
